<template>
  <v-dialog
    v-model="dialog"
    width="600"
    persistent>
    <v-card>
      <v-card-title
        v-if="userType.id === 'patient'"
        id="appIdText"
        class="headline grey lighten-2">
        <span><b>Magnes Nushu App Data Access Request</b></span>
      </v-card-title>
      <v-card-title
        v-if="userType.id === 'doctor'"
        id="appIdText"
        class="headline grey lighten-2">
        <span><b>Magnes Nushu Dashboard Data Access Request</b></span>
      </v-card-title>
      <v-card-title
        v-if="userType.id === 'analysis' || userType.id === 'statistician'"
        id="appIdText"
        class="headline grey lighten-2">
        <span><b>{{ accessState.requestingAppId }}</b></span>
      </v-card-title>
      <v-card-title
        v-if="userType.id === 'nushu_x_user'"
        id="appIdText"
        class="headline grey lighten-2">
        <span><b>Magnes NushuX App Access Request</b></span>
      </v-card-title>
      <v-card-text
        v-if="userType.id === 'patient'"
        style="text-align:left">
        In order to use Magnes Nushu, this app needs your permission to access the following data:
        <ol>
          <li
            v-for="item in patientItems"
            :key="item.message">
            {{ item.message }}
          </li>
        </ol>
        All of the above you have either shared with us during the sign-up process or
        will be created as you use Magnes Nushu (e.g. gait-data and statistics).
        <span
          v-if="expire"
          style="text-align:left">
          <b>will expire after:</b> {{ accessState.expireAfter }}s
        </span>
        <br>
        <span
          v-if="consentMsg"
          v-html="consentMsg" />
      </v-card-text>
      <v-card-text
        v-if="userType.id === 'doctor'"
        style="text-align:left">
        In order to use Magnes Nushu, this website needs your permission to access the following data:
        <ol>
          <li
            v-for="item in doctorItems"
            :key="item.message">
            {{ item.message }}
          </li>
        </ol>
        All of the above you have either shared with us during the sign-up process or
        will be created as you use Magnes Nushu (e.g. patient accesses).
        <span
          v-if="expire"
          style="text-align:left">
          <b>will expire after:</b> {{ accessState.expireAfter }}s
        </span>
        <br>
        <span
          v-if="consentMsg"
          v-html="consentMsg" />
      </v-card-text>
      <v-card-text
        v-if="userType.id === 'analysis' || userType.id === 'statistician'"
        style="text-align:left">
        <h4>Is requesting permission:</h4>
        <ul>
          <li
            v-for="(permission, index) in accessState.requestedPermissions"
            :key="index">
            to {{ permission.level.toLowerCase() }} <u>{{ permission.streamId === '*' ? '* (all data)' : permission.name
            || permission.defaultName }}</u>
          </li>
        </ul>
        <span
          v-if="expire"
          style="text-align:left">
          <b>will expire after:</b> {{ accessState.expireAfter }}s
        </span>
        <br>
        <span
          v-if="consentMsg"
          v-html="consentMsg" />
      </v-card-text>
      <v-card-text
        v-if="userType.id === 'nushu_x_user'"
        style="text-align:left">
        In order to use Magnes NushuX, this app needs your permission to access the following data:
        <ol>
          <li
            v-for="item in nushuXUserItems"
            :key="item.message">
            {{ item.message }}
          </li>
        </ol>
        All of the above, you have either shared with us during the sign-up process or
        will be created as you use Magnes NushuX (e.g. gait-data and statistics).
        <span
          v-if="expire"
          style="text-align:left">
          <b>will expire after:</b> {{ accessState.expireAfter }}s
        </span>
        <br>
        <span
          v-if="consentMsg"
          v-html="consentMsg" />
      </v-card-text>
      <v-alert
        v-if="accessMismatch"
        :value="accessMismatch"
        :type="alertType"
        transition="scale-transition"
        style="text-align:left">
        <b>A different access was already given to this app. Do you want to replace it?</b>
      </v-alert>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          id="refusePermissions"
          @click="closeDialog('refused')">Reject</v-btn>
        <v-btn
          id="acceptPermissions"
          @click="closeDialog('accepted')">Accept</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { marked } from 'marked';
import userTypes from '../../../userTypes.json';

export default {
  props: {
    ctx: { type: Object, default: () => { } },
  },
  data: () => ({
    dialog: true,
    accessState: null,
    checkAppResult: null,
    patientItems: [
      {
        message: 'your Magnes Nushu profile information i.e. name, address, ' +
          'birthdate, biometric and contact information. ' +
          'THIS INFORMATION IS NOT VISIBLE to Magnes Nushu. If you want to share it ' +
          'with your Healthcare Professional, it will be provided to them;',
      },
      {
        message: 'the information about your Magnes Nushu shoes, so that you can ' +
          'register them to your user profile;',
      },
      {
        message: 'your gait data (raw data collected by the shoes and data ' +
          'processed by the cloud) and activities (so that you can always check ' +
          'what you did when);',
      },
      {
        message: 'your statistics to keep you informed about your trends while ' +
          'using Magnes Nushu;',
      },
      { message: 'the name of the clinic providing health services to you;' },
      {
        message: 'your email address and Magnes Nushu profile username ' +
          'to identify you.',
      },
    ],
    doctorItems: [
      { message: 'your contact information (once provided);' },
      { message: 'the title of your clinic that you are affiliated to;' },
      { message: 'your accesses to patient data that you are provided by your patients;' },
      {
        message: 'your email address and Magnes Nushu profile username ' +
          'to identify you.',
      },
    ],
    nushuXUserItems: [
      {
        message: 'your Magnes Nushu profile information i.e. name, ' +
          'birthdate and biometric information.' +
          'THIS INFORMATION IS NOT VISIBLE to Magnes.',
      },
      {
        message: 'the information about your Magnes Nushu shoes, so that you can ' +
          'register them to your user profile;',
      },
      {
        message: 'your gait data (raw data collected by the shoes and data ' +
          'processed by the cloud) and activities (so that you can always check ' +
          'what you did when);',
      },
      {
        message: 'your statistics to keep you informed about your trends while ' +
          'using Magnes NushuX;',
      },
      {
        message: 'your email address and Magnes Nushu profile username ' +
          'to identify you.',
      },
    ],
  }),

  computed: {
    consentMsg: function () {
      if (this.ctx.accessState.clientData != null) {
        const description = this.ctx.accessState.clientData['app-web-auth:description'];
        return description != null ? marked.parse(description.content) : '';
      }
    },
    accessMismatch: function () {
      return (this.ctx.checkAppResult.mismatchingAccess != null);
    },
    expire: function () {
      return (this.ctx.accessState.expireAfter != null);
    },
    userType: function () {
      return (userTypes[this.$route.query.type] !== undefined) ? userTypes[this.$route.query.type] : userTypes['patient'];
    },
  },
  created: function () {
    this.accessState = this.ctx.accessState;
    this.checkAppResult = this.ctx.checkAppResult;
  },
  methods: {
    closeDialog (acceptOrReject) {
      this.dialog = false;
      this.$emit(acceptOrReject);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/bits/Permissions.vue